import MailerLiteAppDrawer from 'modules/apps/apps/MailerLiteApp/drawers/MailerLiteAppDrawer';

const drawers = [MailerLiteAppDrawer];

export default drawers;
